"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVueRuntimeContext = void 0;
const utils_1 = require("./utils");
const getVueRuntimeContext = (vm) => {
    try {
        const name = (0, utils_1.getVueComponentName)(vm);
        const owner = (0, utils_1.getVueComponentOwner)(vm);
        const trace = (0, utils_1.getVueComponentTrace)(vm);
        return { name, owner, trace };
    }
    catch (e) {
        return { name: utils_1.ANONYMOUS_COMPONENT_NAME, trace: '', owner: 'unknown' };
    }
};
exports.getVueRuntimeContext = getVueRuntimeContext;
//# sourceMappingURL=vue.js.map